define("shared/utils/sanitize-html", ["exports", "dompurify"], function (_exports, _dompurify) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  0; //eaimeta@70e063a35619d71f0,"dompurify"eaimeta@70e063a35619d71f
  /**
   * Sanitizes user-authored HTML while preserving the formatting Froala emits (block tags,
   * lists, alignment and indent styles, `fr-*` classes). Deliberately mirrors Later
   * Influence's `sanitize-html` util so the same feedback renders the same way on both sides.
   *
   * Not to be confused with `surveys/questions/sanitize`, whose allowlist has no block tags
   * and would flatten this content.
   */
  const sanitizeHtml = html => _dompurify.default.sanitize(html, {
    // Use DOMPurify's default safe tag list plus common rich-text tags
    ADD_TAGS: ['font', 'center', 'small', 'big', 'strike', 'del', 'ins', 'sub', 'sup', 'hr', 'abbr', 'cite', 'caption'],
    ADD_ATTR: ['target', 'rel', 'color', 'face', 'size', 'align', 'valign', 'bgcolor', 'border', 'cellpadding', 'cellspacing'],
    ALLOW_DATA_ATTR: false,
    FORBID_TAGS: ['script', 'style', 'iframe', 'object', 'embed', 'form', 'input', 'button'],
    FORBID_ATTR: ['onerror', 'onload', 'onclick', 'onmouseover']
  });
  var _default = _exports.default = sanitizeHtml;
});